export const GET_ENTITY_INTERFACE_REQUEST = '[ENTITY INTERFACES] GET_ENTITY_INTERFACE_REQUEST';
export const GET_ENTITY_INTERFACE_SUCCESS = '[ENTITY INTERFACES] GET_ENTITY_INTERFACE_SUCCESS';
export const GET_ENTITY_INTERFACE_FAILED = '[ENTITY INTERFACES] GET_ENTITY_INTERFACE_FAILED';

export const ENTITY_INTERFACE_SEARCH_REQUEST = '[ENTITY INTERFACES] ENTITY_INTERFACE_SEARCH_REQUEST';
export const ENTITY_INTERFACE_SEARCH_SUCCESS = '[ENTITY INTERFACES] ENTITY_INTERFACE_SEARCH_SUCCESS';
export const ENTITY_INTERFACE_SEARCH_FAILED = '[ENTITY INTERFACES] ENTITY_INTERFACE_SEARCH_FAILED';

export const CREATE_ENTITY_INTERFACE_REQUEST = '[ENTITY INTERFACES] CREATE_ENTITY_INTERFACE_REQUEST';
export const CREATE_ENTITY_INTERFACE_SUCCESS = '[ENTITY INTERFACES] CREATE_ENTITY_INTERFACE_SUCCESS';
export const CREATE_ENTITY_INTERFACE_FAILED = '[ENTITY INTERFACES] CREATE_ENTITY_INTERFACE_FAILED';

export const EDIT_ENTITY_INTERFACE_REQUEST = '[ENTITY INTERFACES] EDIT_ENTITY_INTERFACE_REQUEST';
export const EDIT_ENTITY_INTERFACE_SUCCESS = '[ENTITY INTERFACES] EDIT_ENTITY_INTERFACE_SUCCESS';
export const EDIT_ENTITY_INTERFACE_FAILED = '[ENTITY INTERFACES] EDIT_ENTITY_INTERFACE_FAILED';

export const DELETE_ENTITY_INTERFACE_REQUEST = '[ENTITY INTERFACES] DELETE_ENTITY_INTERFACE_REQUEST';
export const DELETE_ENTITY_INTERFACE_SUCCESS = '[ENTITY INTERFACES] DELETE_ENTITY_INTERFACE_SUCCESS';
export const DELETE_ENTITY_INTERFACE_FAILED = '[ENTITY INTERFACES] DELETE_ENTITY_INTERFACE_FAILED';

export const RESET_ENTITY_INTERFACE_FORM = '[ENTITY INTERFACES] RESET_ENTITY_INTERFACE_FORM';
